import React from 'react';
import './Impressum.css';

const Impressum: React.FC = () => {
  return (
    <div className="impressum-container">
      <header className="page-header">
        <div className="header-content">
          <div className="header-text">
            <h1>Legal Notice (Impressum)</h1>
            <p>Legal information and contact details</p>
          </div>
        </div>
      </header>

      <main className="impressum-main">
        <div className="impressum-content">
          <section className="legal-section">
            <h2>Information according to § 5 TMG</h2>
            <div className="contact-info">
              <h3>Service Provider</h3>
              <p>PRO Market History</p>
              <p>Pokemon Revolution Online Community Service</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <div className="contact-info">
              <p><strong>Email:</strong> caenneth@outlook.de</p>
              <p><strong>Discord:</strong> Caenneth</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Disclaimer</h2>
            <div className="disclaimer-content">
              <h3>Liability for Contents</h3>
              <p>
                As service providers, we are liable for own contents of these websites according to Sec. 7, para.1 of the TMG (Telemediengesetz – Tele Media Act by German law). However, according to Sec. 8 to 10 of the TMG, we as service providers are not under obligation to monitor external information provided or stored on our website. Once we have become aware of a specific infringement of the law, we will immediately remove the content in question.
              </p>

              <h3>Liability for Links</h3>
              <p>
                Our offer contains links to external websites of third parties on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the pages is always responsible for the contents of the linked pages.
              </p>

              <h3>Copyright</h3>
              <p>
                The contents and works created by the site operators on these pages are subject to German copyright law. The reproduction, processing, distribution and any kind of exploitation outside the limits of copyright require the written consent of the author or creator.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Data Protection</h2>
            <div className="disclaimer-content">
              <p>
                This service collects and processes user data for the purpose of providing Pokemon Revolution Online price tracking functionality. We collect:
              </p>
              <ul>
                <li>Username and authentication information</li>
                <li>Submitted auction data and screenshots</li>
                <li>User activity logs for service improvement</li>
              </ul>
              <p>
                Data is stored securely and used only for service operation. No personal data is shared with third parties without consent.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Service Information</h2>
            <div className="disclaimer-content">
              <p>
                This service is provided as-is for the Pokemon Revolution Online community. Price data is user-submitted and verified by community reviewers. While we strive for accuracy, we cannot guarantee the completeness or correctness of all price information.
              </p>
              <p>
                Pokemon Revolution Online is not affiliated with this price tracking service. This is an independent community project.
              </p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Impressum;
